import { Controller } from "@hotwired/stimulus";
// import httpService from "../services/HttpService"; // keep if you plan to use posturl fetch

export default class ModalContainerController extends Controller {
  static targets = ["container"];

  connect() {
    this.boundOpenDialog = this.openDialog.bind(this);
    document.addEventListener("open-dialog", this.boundOpenDialog);
  }

  disconnect() {
    document.removeEventListener("open-dialog", this.boundOpenDialog);
  }

  async openDialog(event) {
    const { dialogId, posturl } = event.detail || {};
    if (!dialogId) return;

    // Close all OTHER modals, but ignore (do not close) the one we're opening
    document.dispatchEvent(
      new CustomEvent("modal:close-all", {
        detail: { exceptId: dialogId },
        bubbles: true
      })
    );

    // Let focus/aria settle before showing another
    await new Promise(requestAnimationFrame);

    // ⛔️ Do NOT remove existing modals here anymore.
    // If you want to fetch a fresh modal for this dialogId, do it explicitly:
    // if (posturl) {
    //   const res = await httpService.get(posturl);
    //   if (res.type === "html") {
    //     Turbo.renderStreamMessage(res.data);
    //   }
    // } else {
    //   // If no fetch, just ensure an existing modal with this ID is visible
    //   const modalRoot = this.containerTarget.querySelector(
    //     `[data-modal-dialog-id-value="${dialogId}"] [data-modal-target="modal"]`
    //   );
    //   if (modalRoot) {
    //     modalRoot.classList.remove("hidden");
    //     modalRoot.removeAttribute("inert");
    //     modalRoot.removeAttribute("aria-hidden");
    //   }
    // }
  }
}